import { Injectable, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NavigationService {
  @Output()
  filtersComplete: Subject<boolean> = new Subject<boolean>();

  defaultFiltersComplete: boolean = true;

  updateFiltersComplete(complete: boolean) {
    this.filtersComplete.next(complete);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/navigation.service.ts